import { z } from "zod";
import {
    NativeInvoiceCustomTermType,
    NativeInvoiceTermType,
} from "@common/helpers/invoice-terms.helper";

export const nativeInvoiceCustomTermSchema = z
    .object({
        type: z.nativeEnum(NativeInvoiceCustomTermType),
        days: z.number().int().min(0).nullable(),
        dayOfMonth: z.number().int().min(1).max(31).nullable(),
    })
    .strict()
    .superRefine((value, ctx) => {
        if (value.type === NativeInvoiceCustomTermType.DUE_IN_DAYS) {
            if (value.days == null) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["days"],
                    message: "days is required when custom term is due in days",
                });
            }
            return;
        }
        if (value.dayOfMonth == null) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["dayOfMonth"],
                message:
                    "dayOfMonth is required when custom term is due by day of month",
            });
        }
    });

export const nativeInvoiceDueDateRuleFieldsSchema = z.object({
    termType: z.nativeEnum(NativeInvoiceTermType).nullable().optional(),
    customTerm: nativeInvoiceCustomTermSchema.nullable().optional(),
});

export const nativeInvoiceEmailIntentFieldsSchema = z.object({
    isEmailSubjectAutomatic: z.boolean().optional(),
    isEmailMessageAutomatic: z.boolean().optional(),
});

export type NativeInvoiceDueDateRuleFields = z.infer<
    typeof nativeInvoiceDueDateRuleFieldsSchema
>;

export function refineNativeInvoiceDueDateRule(
    body: NativeInvoiceDueDateRuleFields,
    ctx: z.RefinementCtx,
): void {
    if (body.customTerm != null && body.termType === undefined) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["termType"],
            message: "termType is required when customTerm is provided",
        });
        return;
    }
    if (
        body.termType === NativeInvoiceTermType.CUSTOM &&
        body.customTerm == null
    ) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["customTerm"],
            message: "customTerm is required when termType is custom",
        });
        return;
    }
    if (
        body.termType != null &&
        body.termType !== NativeInvoiceTermType.CUSTOM &&
        body.customTerm != null
    ) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["customTerm"],
            message: "customTerm is only allowed when termType is custom",
        });
    }
}
